import React from 'react'
import styled, { CSSObject } from '@emotion/styled'
import { useModal } from 'shop/hooks'
import { PotentialLoyaltyGains as PotentialLoyaltyGainsType } from 'shop/types/cart'
import AnimatedRow from './AnimatedRow'

interface Props {
  potentialLoyaltyGains: PotentialLoyaltyGainsType
}

const PotentialLoyaltyGains: React.FC<Props> = ({ potentialLoyaltyGains }) => {
  const { openModal } = useModal()
  const { points, stamps } = potentialLoyaltyGains
  const { total: stampsTotal } = stamps
  const { total: pointsTotal } = points
  const isLoggedIn = localStorage.getItem('customerId') !== null

  const handleSignInClick = () => openModal('login')

  const createLoyaltyGainContent = (
    type: 'stamps' | 'points',
    total: number
  ) => {
    const loyaltyType = type === 'stamps' ? 'Stamps' : 'Points'

    const copy = (
      <Copy>
        {isLoggedIn ? (
          `Earn ${total} ${type} with this order`
        ) : (
          <>
            <SignIn onClick={handleSignInClick}>Sign in</SignIn>
            {` to earn ${total} ${type} on this order`}
          </>
        )}
      </Copy>
    )

    const gainsDisplay = (
      <PointsContainer>
        <Plus>+</Plus>
        <Points>{`${total} ${loyaltyType}`}</Points>
      </PointsContainer>
    )

    return (
      <>
        {copy}
        {gainsDisplay}
      </>
    )
  }

  return (
    <Container hasMultipleRows={!!stampsTotal && !!pointsTotal}>
      <AnimatedRow
        shouldShow={!!stampsTotal}
        maxHeight='30px'
        testId='animated-row-stamps'
        additionalStyles={{
          display: 'grid',
          gridTemplateColumns: '1fr max-content',
          alignItems: 'center'
        }}
      >
        {createLoyaltyGainContent('stamps', stampsTotal)}
      </AnimatedRow>
      <AnimatedRow
        shouldShow={!!pointsTotal}
        maxHeight='30px'
        testId='animated-row-points'
        additionalStyles={{
          display: 'grid',
          gridTemplateColumns: '1fr max-content',
          alignItems: 'center'
        }}
      >
        {createLoyaltyGainContent('points', pointsTotal)}
      </AnimatedRow>
    </Container>
  )
}

const Container = styled.div<{ hasMultipleRows: boolean }>(
  ({ hasMultipleRows }): CSSObject => ({
    padding: '0 0 8px',
    overflow: 'hidden',
    display: 'flex',
    gap: hasMultipleRows ? '4px' : '0',
    flexDirection: 'column'
  })
)

const SignIn = styled.span(() => ({
  textDecoration: 'underline',
  cursor: 'pointer'
}))

const Copy = styled.p(() => ({
  fontSize: '14px',
  fontWeight: 500,
  margin: 0
}))

const Plus = styled.span(() => ({
  color: '#59595A'
}))

const Points = styled.p(() => ({
  fontSize: '16px',
  margin: 0
}))

const PointsContainer = styled.div(() => ({
  backgroundColor: '#FFE7BA',
  padding: '4px 8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

export default PotentialLoyaltyGains
